import React, { useState } from 'react';
import {
    MenuFoldOutlined,
    MenuUnfoldOutlined,
} from '@ant-design/icons';
import { Button, Layout, Menu } from 'antd';
import { Route, Routes, useHref } from 'react-router-dom';

import Brands from '../Pages/Params/Brands/Brands';
import MediaManager from '../Pages/Media/MediaManager';
import Models from '../Pages/Params/Models/Models';
import Countries from '../Pages/Params/Countrys/Countrys';
import Categories from '../Pages/Params/Categorys/Categories';
import Manufacturer from '../Pages/Params/Manufacturers/Manufacturer';
import Colors from '../Pages/Params/Colors/Colors';
import Units from '../Pages/Params/Units/Units';
import Products from '../Pages/Params/Products/Products';
import Coming from '../Pages/InCome/Coming';
import Inventary from '../Pages/InCome/Inventary';
import CominHistory from '../Pages/InCome/CominHistory';
import Configs from '../Pages/Configs/Configs';
import Customers from '../Pages/Customers/Customers';
import Suplier from '../Pages/Supliers/Suplier';
import AllTransactions from '../Pages/Transactions/AllTransactions';
import Reprice from '../Pages/InCome/Reprice';
import { menuItems } from './menuItems';
import Pos from '../Pages/Pos/Pos';
import Teams from '../Pages/Teams/Teams';
import Roles from '../Pages/Roles/Roles';
import Shops from '../Pages/Shops/Shops';
import LeftToolbar from './Comps/LeftToolbar';
import PosHistory from '../Pages/Pos/PosHistory';
import Dashboard from '../Pages/Dashboard/Dashboard';
import MainSlider from '../Pages/MainSlider/MainSlider';
import Company from '../Pages/Company/Company';
import Comments from '../Pages/Comments/Comments';
import Orders from '../Pages/Orders/Orders';
import Jurnal from '../Pages/Jurnal/Jurnal';
import BTSConfigs from '../Pages/Params/BTSConfigs/BTSConfigs';
import Discounts from '../Pages/Discounts/Discounts';
import OrderSingle from '../Pages/Orders/OrderSingle';
import Perenos from '../Pages/Perenos/Perenos';
import ShopProducts from '../Pages/Pos/ShopProducts';
import Warehouse from '../Pages/Warehouse/Warehouse';
import WarehouseS from '../Pages/Warehouse/WarehouseS';
import BtsManager from '../Pages/BTS/BtsManager';

const { Header, Sider, Content } = Layout;

const getMobile = () => typeof window !== 'undefined' && window.innerWidth < 992;

export default function AdminLayout() {
    const [isMobile, setIsMobile] = useState(getMobile());
    const [collapsed, setCollapsed] = useState(getMobile());
    let uri = useHref();

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Sider
                trigger={null}
                collapsible
                collapsed={collapsed}
                width={280}
                collapsedWidth={isMobile ? 0 : 80}
                breakpoint="lg"
                onBreakpoint={(broken) => { setIsMobile(broken); setCollapsed(broken); }}
                style={{
                    height: '100vh',
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    bottom: 0,
                    background: 'var(--bg-sidebar)',
                    borderRight: '1px solid var(--border)',
                    boxShadow: 'var(--shadow-sm)',
                    zIndex: 1000,
                    transition: 'all var(--transition-base)',
                }}
            >
                <div style={{
                    height: 64,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: collapsed ? 'center' : 'flex-start',
                    gap: 12,
                    borderBottom: '1px solid var(--border)',
                    padding: collapsed ? '0' : '0 20px',
                }}>
                    <div style={{
                        width: 36,
                        height: 36,
                        flexShrink: 0,
                        borderRadius: 'var(--radius-md)',
                        background: 'var(--primary)',
                        color: '#fff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 700,
                        fontSize: 18,
                    }}>
                        G
                    </div>
                    {!collapsed && (
                        <span style={{
                            fontSize: 18,
                            fontWeight: 700,
                            letterSpacing: '-0.02em',
                            color: 'var(--text-primary)',
                            whiteSpace: 'nowrap',
                        }}>
                            Gabarit<span style={{ color: 'var(--primary)' }}>Avto</span>
                        </span>
                    )}
                </div>
                <div style={{ height: 'calc(100vh - 64px)', overflowY: 'auto', overflowX: 'hidden' }}>
                    <Menu
                        mode="inline"
                        selectedKeys={[uri]}
                        items={menuItems}
                        onClick={() => { if (isMobile) setCollapsed(true); }}
                        style={{
                            background: 'transparent',
                            borderRight: 'none',
                            padding: '8px',
                        }}
                    />
                </div>
            </Sider>

            {/* Mobil: menyu ochilganda orqa fon (bosilsa yopiladi) */}
            {isMobile && !collapsed && (
                <div
                    onClick={() => setCollapsed(true)}
                    style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 999 }}
                />
            )}

            <Layout style={{ marginLeft: isMobile ? 0 : (collapsed ? 80 : 280), transition: 'margin-left var(--transition-base)' }}>
                <Header style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 99,
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: isMobile ? '0 12px' : '0 24px',
                    background: 'var(--bg-header)',
                    borderBottom: '1px solid var(--border)',
                    boxShadow: 'var(--shadow-xs)',
                    transition: 'all var(--transition-base)',
                }}>
                    <Button
                        type="text"
                        icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                        onClick={() => setCollapsed(!collapsed)}
                        style={{
                            fontSize: '16px',
                            width: 40,
                            height: 40,
                            borderRadius: 'var(--radius-md)',
                            color: 'var(--text-secondary)',
                        }}
                    />
                    <LeftToolbar />
                </Header>

                <Content style={{
                    margin: isMobile ? '12px' : '24px',
                    padding: 0,
                    minHeight: 'calc(100vh - 64px - 48px)',
                }}>
                    <div style={{
                        background: 'var(--bg-card)',
                        borderRadius: 'var(--radius-lg)',
                        boxShadow: 'var(--shadow-sm)',
                        border: '1px solid var(--border)',
                        minHeight: 'calc(100vh - 136px)',
                        overflow: 'hidden',
                    }}>
                        <div style={{ padding: '24px' }}>
                            <Routes>
                                <Route path={'/*'} element={<Dashboard />} />
                                <Route path={'/params'} element={<div>Params</div>} />
                                <Route path={'/params/brands'} element={<Brands />} />
                                <Route path={'/params/categories'} element={<Categories />} />
                                <Route path={'/sklad/products'} element={<Products />} />
                                <Route path={'/params/models'} element={<Models />} />
                                <Route path={'/params/countries'} element={<Countries />} />
                                <Route path={'/params/manufacturers'} element={<Manufacturer />} />
                                <Route path={'/params/colors'} element={<Colors />} />
                                <Route path={'/params/units'} element={<Units />} />
                                <Route path={'/params/configs'} element={<Configs />} />
                                <Route path={'/charts'} element={<div>Charts</div>} />
                                <Route path={'/pos'} element={<Pos />} />
                                <Route path={'/pos/history'} element={<PosHistory />} />
                                <Route path={'/orders'} element={<Orders />} />
                                <Route path={'/bts'} element={<BtsManager />} />
                                <Route path={'/users'} element={<div>Users</div>} />
                                <Route path={'/permissions'} element={<div>Permissions</div>} />
                                <Route path={'/configs'} element={<Configs />} />
                                <Route path={'/media'} element={<MediaManager />} />
                                <Route path={'/income/coming'} element={<Coming />} />
                                <Route path={'/income/sell'} element={<Inventary />} />
                                <Route path={'/income/history'} element={<CominHistory />} />
                                <Route path={'/income/prices'} element={<Reprice />} />
                                <Route path={'/income/perenos'} element={<Perenos />} />
                                <Route path={'/customers'} element={<Customers />} />
                                <Route path={'/suppliers'} element={<Suplier />} />
                                <Route path={'/transactions'} element={<AllTransactions />} />
                                <Route path={'/teams'} element={<Teams />} />
                                <Route path={'/params/roles'} element={<Roles />} />
                                <Route path={'/params/shops'} element={<Shops />} />
                                <Route path={'/sliders'} element={<MainSlider />} />
                                <Route path={'/company'} element={<Company />} />
                                <Route path={'/comments'} element={<Comments />} />
                                <Route path={'/sklad/btsconfigs'} element={<BTSConfigs />} />
                                <Route path={'/jurnal'} element={<Jurnal />} />
                                <Route path={'/order/:id'} element={<OrderSingle />} />
                                <Route path={'/discounts'} element={<Discounts />} />
                                <Route path='/pos/products' element={<ShopProducts />} />
                                <Route path='/params/warehouses' element={<Warehouse />} />
                                <Route path='/warehouse/:id' element={<WarehouseS />} />
                                <Route path={'*'} element={
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        height: '60vh',
                                        color: 'var(--text-muted)',
                                    }}>
                                        <h2 style={{ fontSize: '64px', fontWeight: 700, marginBottom: '16px' }}>404</h2>
                                        <p style={{ fontSize: '16px' }}>Sahifa topilmadi</p>
                                    </div>
                                } />
                            </Routes>
                        </div>
                    </div>
                </Content>
            </Layout>
        </Layout>
    );
}
